import React, { FC, useState } from 'react';

import { InputNumberProps } from 'antd';
import { NamePath } from 'antd/es/form/interface';

import { NumberInputFormItem } from '@/components/form';

import { CellData } from '../cell-data';

type TEditableNumberFormItemProps = {
	name: NamePath;
	itemValue?: string | number;
	numberInputProps?: InputNumberProps<number>;
};

export const EditableNumberFormItem: FC<TEditableNumberFormItemProps> = ({
	name,
	itemValue,
	numberInputProps,
}) => {
	const [editMode, setEditMode] = useState<boolean>(true);
	const [shouldAutofocus, setShouldAutofocus] = useState<boolean>(false);

	return editMode ? (
		<NumberInputFormItem
			formItemProps={{
				name: name,
				rules: [{ required: false }],
				style: { marginBottom: 0 },
			}}
			inputNumberProps={{
				autoFocus: shouldAutofocus,
				controls: false,
				onBlur: (e) => {
					if (e.target.value === '') {
						e.preventDefault();
						e.stopPropagation();
						return;
					}

					setEditMode(false);
					setShouldAutofocus(true);
				},
				...numberInputProps,
			}}
		/>
	) : (
		<CellData
			style={{ width: '100%' }}
			onClick={() => {
				setEditMode(true);
			}}
		>
			{itemValue}
		</CellData>
	);
};
